import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIllustrationNoRoles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 200,
	viewBox: "0 0 200 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_31_1817)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M100 200C155.228 200 200 155.228 200 100C200 44.7715 155.228 0 100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200Z",
				fill: "#FFD8A2"
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter0_d_31_1817)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M146.3 43.0878L65.3 37.4178C61.9863 37.1858 59.1119 39.6841 58.88 42.9978L51.32 150.998C51.088 154.312 53.5863 157.186 56.9 157.418L137.9 163.088C141.214 163.32 144.088 160.822 144.32 157.508L151.88 49.5078C152.112 46.1941 149.614 43.3198 146.3 43.0878Z",
					fill: "#C8D5FF"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter1_d_31_1817)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M135.001 40.105H54.001C50.6873 40.105 48.001 42.7913 48.001 46.105V154.105C48.001 157.419 50.6873 160.105 54.001 160.105H135.001C138.315 160.105 141.001 157.419 141.001 154.105V46.105C141.001 42.7913 138.315 40.105 135.001 40.105Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .102,
				d: "M126 72.098H61C59.8954 72.098 59 72.9935 59 74.098V75.098C59 76.2026 59.8954 77.098 61 77.098H126C127.105 77.098 128 76.2026 128 75.098V74.098C128 72.9935 127.105 72.098 126 72.098Z",
				fill: "#0D2976"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M98 130.097H62C60.3431 130.097 59 131.44 59 133.097V146.097C59 147.754 60.3431 149.097 62 149.097H98C99.6569 149.097 101 147.754 101 146.097V133.097C101 131.44 99.6569 130.097 98 130.097Z",
				fill: "#6EF29C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M71.73 142.153C71.2447 142.153 70.8317 142.053 70.491 141.852C70.155 141.647 69.8983 141.355 69.721 140.977C69.5437 140.599 69.455 140.149 69.455 139.626C69.455 139.103 69.5437 138.655 69.721 138.282C69.8983 137.904 70.155 137.615 70.491 137.414C70.8317 137.209 71.2447 137.106 71.73 137.106C72.0847 137.106 72.3997 137.162 72.675 137.274C72.9503 137.381 73.1907 137.542 73.396 137.757L73.214 138.107C72.9853 137.897 72.7567 137.745 72.528 137.652C72.2993 137.554 72.0333 137.505 71.73 137.505C71.1373 137.505 70.687 137.692 70.379 138.065C70.071 138.434 69.917 138.954 69.917 139.626C69.917 140.298 70.071 140.821 70.379 141.194C70.687 141.567 71.1373 141.754 71.73 141.754C72.0333 141.754 72.2993 141.707 72.528 141.614C72.7567 141.516 72.9853 141.362 73.214 141.152L73.396 141.502C73.1907 141.717 72.948 141.88 72.668 141.992C72.3927 142.099 72.08 142.153 71.73 142.153ZM74.3592 142.097V139.409C74.3592 139.274 74.3545 139.138 74.3452 139.003C74.3405 138.863 74.3288 138.725 74.3102 138.59H74.7302L74.7862 139.395L74.7022 139.402C74.7488 139.206 74.8328 139.045 74.9542 138.919C75.0755 138.788 75.2155 138.69 75.3742 138.625C75.5328 138.56 75.6962 138.527 75.8642 138.527C75.9248 138.527 75.9808 138.532 76.0322 138.541C76.0882 138.546 76.1395 138.555 76.1862 138.569L76.1722 138.954C76.1162 138.935 76.0602 138.924 76.0042 138.919C75.9482 138.914 75.8875 138.912 75.8222 138.912C75.6122 138.912 75.4278 138.963 75.2692 139.066C75.1152 139.169 74.9962 139.299 74.9122 139.458C74.8282 139.617 74.7862 139.778 74.7862 139.941V142.097H74.3592ZM78.2706 142.153C77.7386 142.153 77.3162 141.994 77.0036 141.677C76.6956 141.36 76.5416 140.919 76.5416 140.354C76.5416 139.981 76.6092 139.659 76.7446 139.388C76.8846 139.117 77.0782 138.907 77.3256 138.758C77.5729 138.604 77.8599 138.527 78.1866 138.527C78.4992 138.527 78.7629 138.595 78.9776 138.73C79.1922 138.861 79.3579 139.05 79.4746 139.297C79.5912 139.54 79.6496 139.829 79.6496 140.165V140.361H76.8496V140.053H79.3836L79.2646 140.144C79.2646 139.747 79.1736 139.437 78.9916 139.213C78.8096 138.984 78.5389 138.87 78.1796 138.87C77.7969 138.87 77.4982 139.003 77.2836 139.269C77.0689 139.53 76.9616 139.878 76.9616 140.312V140.361C76.9616 140.828 77.0759 141.182 77.3046 141.425C77.5379 141.668 77.8622 141.789 78.2776 141.789C78.4922 141.789 78.6929 141.756 78.8796 141.691C79.0662 141.626 79.2459 141.514 79.4186 141.355L79.5936 141.67C79.4442 141.824 79.2506 141.943 79.0126 142.027C78.7746 142.111 78.5272 142.153 78.2706 142.153ZM81.8964 142.153C81.579 142.153 81.3037 142.081 81.0704 141.936C80.837 141.791 80.6574 141.584 80.5314 141.313C80.4054 141.042 80.3424 140.718 80.3424 140.34C80.3424 139.962 80.4054 139.64 80.5314 139.374C80.662 139.103 80.844 138.896 81.0774 138.751C81.3107 138.602 81.5837 138.527 81.8964 138.527C82.2184 138.527 82.496 138.611 82.7294 138.779C82.9674 138.947 83.1237 139.176 83.1984 139.465H83.1144L83.1844 138.59H83.5974C83.5834 138.725 83.5694 138.858 83.5554 138.989C83.546 139.12 83.5414 139.248 83.5414 139.374V142.097H83.1144V141.222H83.1914C83.1167 141.511 82.9604 141.74 82.7224 141.908C82.489 142.071 82.2137 142.153 81.8964 142.153ZM81.9524 141.789C82.3117 141.789 82.5964 141.665 82.8064 141.418C83.0164 141.171 83.1214 140.811 83.1214 140.34C83.1214 139.869 83.0164 139.509 82.8064 139.262C82.5964 139.015 82.3117 138.891 81.9524 138.891C81.593 138.891 81.306 139.015 81.0914 139.262C80.8814 139.509 80.7764 139.869 80.7764 140.34C80.7764 140.811 80.8814 141.171 81.0914 141.418C81.306 141.665 81.593 141.789 81.9524 141.789ZM85.8361 142.153C85.5234 142.153 85.2831 142.06 85.1151 141.873C84.9518 141.686 84.8701 141.399 84.8701 141.012V138.933H84.1701V138.59H84.8701V137.61L85.2971 137.47V138.59H86.3331V138.933H85.2971V140.949C85.2971 141.243 85.3438 141.455 85.4371 141.586C85.5304 141.717 85.6798 141.782 85.8851 141.782C85.9784 141.782 86.0601 141.773 86.1301 141.754C86.2048 141.735 86.2678 141.714 86.3191 141.691V142.069C86.2631 142.092 86.1908 142.111 86.1021 142.125C86.0134 142.144 85.9248 142.153 85.8361 142.153ZM88.5313 142.153C87.9993 142.153 87.577 141.994 87.2643 141.677C86.9563 141.36 86.8023 140.919 86.8023 140.354C86.8023 139.981 86.87 139.659 87.0053 139.388C87.1453 139.117 87.339 138.907 87.5863 138.758C87.8336 138.604 88.1206 138.527 88.4473 138.527C88.76 138.527 89.0236 138.595 89.2383 138.73C89.453 138.861 89.6186 139.05 89.7353 139.297C89.852 139.54 89.9103 139.829 89.9103 140.165V140.361H87.1103V140.053H89.6443L89.5253 140.144C89.5253 139.747 89.4343 139.437 89.2523 139.213C89.0703 138.984 88.7996 138.87 88.4403 138.87C88.0576 138.87 87.759 139.003 87.5443 139.269C87.3296 139.53 87.2223 139.878 87.2223 140.312V140.361C87.2223 140.828 87.3366 141.182 87.5653 141.425C87.7986 141.668 88.123 141.789 88.5383 141.789C88.753 141.789 88.9536 141.756 89.1403 141.691C89.327 141.626 89.5066 141.514 89.6793 141.355L89.8543 141.67C89.705 141.824 89.5113 141.943 89.2733 142.027C89.0353 142.111 88.788 142.153 88.5313 142.153Z",
				fill: "#0D2976"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .102,
				d: "M127 84.097H61C59.8954 84.097 59 84.9925 59 86.097C59 87.2016 59.8954 88.097 61 88.097H127C128.105 88.097 129 87.2016 129 86.097C129 84.9925 128.105 84.097 127 84.097Z",
				fill: "#0D2976"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .102,
				d: "M127 90.097H61C59.8954 90.097 59 90.9925 59 92.097C59 93.2016 59.8954 94.097 61 94.097H127C128.105 94.097 129 93.2016 129 92.097C129 90.9925 128.105 90.097 127 90.097Z",
				fill: "#0D2976"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .102,
				d: "M117 96.097H61C59.8954 96.097 59 96.9925 59 98.097C59 99.2016 59.8954 100.097 61 100.097H117C118.105 100.097 119 99.2016 119 98.097C119 96.9925 118.105 96.097 117 96.097Z",
				fill: "#0D2976"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.651 59.098V54.163H61.597C62.1057 54.163 62.5 54.282 62.78 54.52C63.06 54.758 63.2 55.094 63.2 55.528C63.2 55.808 63.137 56.0484 63.011 56.249C62.885 56.445 62.71 56.5967 62.486 56.704C62.262 56.8067 62.003 56.858 61.709 56.858L61.842 56.781H61.94C62.1313 56.781 62.3017 56.8277 62.451 56.921C62.6003 57.0097 62.7193 57.1637 62.808 57.383L63.494 59.098H63.018L62.374 57.46C62.2853 57.222 62.157 57.0704 61.989 57.005C61.821 56.935 61.6063 56.9 61.345 56.9H60.085V59.098H59.651ZM60.085 56.536H61.541C61.9377 56.536 62.2387 56.4497 62.444 56.277C62.654 56.1044 62.759 55.857 62.759 55.535C62.759 55.2084 62.654 54.961 62.444 54.793C62.2387 54.6204 61.9377 54.534 61.541 54.534H60.085V56.536ZM65.7111 59.154C65.3798 59.154 65.0928 59.0817 64.8501 58.937C64.6121 58.7924 64.4278 58.5847 64.2971 58.314C64.1665 58.0434 64.1011 57.719 64.1011 57.341C64.1011 56.9677 64.1665 56.6457 64.2971 56.375C64.4278 56.1044 64.6121 55.8967 64.8501 55.752C65.0928 55.6027 65.3798 55.528 65.7111 55.528C66.0378 55.528 66.3201 55.6027 66.5581 55.752C66.8008 55.8967 66.9875 56.1044 67.1181 56.375C67.2535 56.6457 67.3211 56.9677 67.3211 57.341C67.3211 57.719 67.2535 58.0434 67.1181 58.314C66.9875 58.5847 66.8008 58.7924 66.5581 58.937C66.3201 59.0817 66.0378 59.154 65.7111 59.154ZM65.7111 58.79C66.0658 58.79 66.3505 58.6664 66.5651 58.419C66.7798 58.1717 66.8871 57.8124 66.8871 57.341C66.8871 56.8697 66.7798 56.5104 66.5651 56.263C66.3505 56.0157 66.0658 55.892 65.7111 55.892C65.3518 55.892 65.0648 56.0157 64.8501 56.263C64.6401 56.5104 64.5351 56.8697 64.5351 57.341C64.5351 57.8124 64.6401 58.1717 64.8501 58.419C65.0648 58.6664 65.3518 58.79 65.7111 58.79ZM68.2558 59.098V53.946H68.6828V59.098H68.2558ZM71.3536 59.154C70.8216 59.154 70.3992 58.9954 70.0866 58.678C69.7786 58.3607 69.6246 57.9197 69.6246 57.355C69.6246 56.9817 69.6922 56.6597 69.8276 56.389C69.9676 56.1184 70.1612 55.9084 70.4086 55.759C70.6559 55.605 70.9429 55.528 71.2696 55.528C71.5822 55.528 71.8459 55.5957 72.0606 55.731C72.2752 55.8617 72.4409 56.0507 72.5576 56.298C72.6742 56.5407 72.7326 56.83 72.7326 57.166V57.362H69.9326V57.054H72.4666L72.3476 57.145C72.3476 56.7484 72.2566 56.438 72.0746 56.214C71.8926 55.9854 71.6219 55.871 71.2626 55.871C70.8799 55.871 70.5812 56.004 70.3666 56.27C70.1519 56.5314 70.0446 56.879 70.0446 57.313V57.362C70.0446 57.8287 70.1589 58.1834 70.3876 58.426C70.6209 58.6687 70.9452 58.79 71.3606 58.79C71.5752 58.79 71.7759 58.7574 71.9626 58.692C72.1492 58.6267 72.3289 58.5147 72.5016 58.356L72.6766 58.671C72.5272 58.825 72.3336 58.944 72.0956 59.028C71.8576 59.112 71.6102 59.154 71.3536 59.154Z",
				fill: "#0D2976"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .102,
				d: "M127 107.097H61C59.8954 107.097 59 107.992 59 109.097C59 110.202 59.8954 111.097 61 111.097H127C128.105 111.097 129 110.202 129 109.097C129 107.992 128.105 107.097 127 107.097Z",
				fill: "#0D2976"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .102,
				d: "M117 113.097H61C59.8954 113.097 59 113.992 59 115.097C59 116.202 59.8954 117.097 61 117.097H117C118.105 117.097 119 116.202 119 115.097C119 113.992 118.105 113.097 117 113.097Z",
				fill: "#0D2976"
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter2_d_31_1817)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M190 30C190 18.9543 181.046 10 170 10C158.954 10 150 18.9543 150 30C150 41.0457 158.954 50 170 50C181.046 50 190 41.0457 190 30Z",
					fill: "#FF7181"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M172.578 29.5L176.484 33.4453C176.992 33.9141 176.992 34.6953 176.484 35.1641L175.625 36.0234C175.156 36.5312 174.375 36.5312 173.906 36.0234L170 32.1172L166.055 36.0234C165.586 36.5312 164.805 36.5312 164.336 36.0234L163.477 35.1641C162.969 34.6953 162.969 33.9141 163.477 33.4453L167.383 29.5L163.477 25.5938C162.969 25.125 162.969 24.3438 163.477 23.875L164.336 23.0156C164.805 22.5078 165.586 22.5078 166.055 23.0156L170 26.9219L173.906 23.0156C174.375 22.5078 175.156 22.5078 175.625 23.0156L176.484 23.875C176.992 24.3438 176.992 25.125 176.484 25.5938L172.578 29.5Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_31_1817",
			x: 39.3051,
			y: 31.4029,
			width: 124.59,
			height: 149.7,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 6 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 6 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.102 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_31_1817"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_31_1817",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter1_d_31_1817",
			x: 38.001,
			y: 40.105,
			width: 113,
			height: 140,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 10 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.102 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_31_1817"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_31_1817",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter2_d_31_1817",
			x: 144,
			y: 7,
			width: 52,
			height: 52,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 3 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0509804 0 0 0 0 0.160784 0 0 0 0 0.462745 0 0 0 0.2 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_31_1817"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_31_1817",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_31_1817",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 200,
				height: 200,
				fill: "white"
			})
		})
	] })]
});
export default SvgIllustrationNoRoles;
